/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from 'react';
import { Box, Stack, Button, TextField, Typography } from '@mui/material';

import { exerciseOptions, fetchData } from '../utils/fetchData';
import HorizontalScrollbar from './HorizontalScrollbar';


const SearchExercises = ({setExercises, bodyPart, setBodyPart}) => {
  
    const [ search, setSearch ] = useState('');
    const [ bodyParts, setBodyParts ] = useState([]);
   
    
    useEffect(() => {
        const fetchExercisesData = async () => {
            const bodyPartsData = await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList', exerciseOptions);
            
            setBodyParts(['all', ...bodyPartsData])
        }
        fetchExercisesData();
    }, [])
    

    
    const handleSearch = async () => {
        if (search) {
           
            const exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);
            
            const searchedExercises = exercisesData.filter(
                item => item.name.toLowerCase().includes(search)
                    || item.target.toLowerCase().includes(search)
                    || item.bodyPart.toLowerCase().includes(search)
                    || item.equipment.toLowerCase().includes(search)
            );
            window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
            setSearch('');
            setExercises(searchedExercises);
        }
    }
   
  return (
      <Stack
          sx={{
            alignItems: "center",
            mt:"37px",
            justifyContent: "center",
            p:"20px"
          }}>
            <Typography
                fontWeight={700}
                color="#00195b"
              sx={{
                  fontSize: { lg: '44px', xs: '30px' },
                 
                  mb: "50px",
                  textAlign:"center"
              }}> 
                Awesome Exercises You <br/> Should Know 
            </Typography>
          <Box
              sx={{
                  position: 'relative',
                  mb: '72px',
              }}>
              <TextField
                  placeholder= "Search Exercises"
                  sx={{
                      input: {
                        fontWeight: '700',
                        /*border-style WOULD work here if visible ;) */
                        //  border: 'none',
                        // borderRadius: '40px',
                          backgroundColor: '#fff',
                          width: { lg: '800px', xs: '350px' },
                      },
                        height: "76px",
                        value:{search},
                        type: "text" 
                  }}
                  onChange = {(e) => setSearch(e.target.value.toLowerCase())} />
                    
              <Button className = "search-btn"
                  sx={{
                      bgcolor: '#239beb',
                      color: '#fff',
                      textTransform: 'none',
                      width: { lg: '175px', xs: '80px' },
                      fontSize: { lg: '20px', xs: '14px' },
                      height: '56px',
                      position: 'absolute',
                      type: "text",
                      // needed to set the button inside the TextField??
                      right: '0', 
                      
                  }}
                  onClick={handleSearch}
              >
                Search 
              </Button>
            </Box>
          <Box
              sx={{
                  position: 'relative',
                  width: '100%',
                  p: '20px'
              }}>
          
              <HorizontalScrollbar
                  data={bodyParts}
                  bodyParts //this one is needed to display BodyParts
                  bodyPart={bodyPart}
                  setBodyPart={setBodyPart}
              />
            </Box>
            
        </Stack>
  )
}

export default SearchExercises